export default function setHotjarIdentity({
  displayName,
  email,
  userID,
  username
}: {
  displayName: string;
  email: string;
  userID: string;
  username: string;
}) {
  if (typeof (window as any).hj === "function") {
    (window as any).hj("identify", userID, { displayName, email, userID, username });
  }
}
